// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__nwxxE","title":"InfoRow_title__30xwy"};